













































import Vue from 'vue';
import OrgService from '@/api/org.service';
import ReactivationOnboardInitial from '@/components/Reactivation/ReactivationOnboardInitial.vue';
import ReactivationWaitlistCard from '@/components/Reactivation/ReactivationWaitlistCard.vue';
import {
  CREATE_REACTIVATION_CAMPAIGN_BLUEPRINT,
  FETCH_ORG_COUPONS,
  FETCH_ORG_PRICES,
  FETCH_ORG_PRODUCTS,
  FETCH_REACTIVATION_BLOCK_COUNTS,
  FETCH_REACTIVATION_CAMPAIGN_COUNTS,
  FETCH_REACTIVATION_EMAIL_OPEN_COUNTS,
  SYNC_REACTIVATION,
} from '@/store/action-types';
import { mapGetters } from 'vuex';
import eventBus from '@/helpers/event-bus';

export default Vue.extend({
  name: 'Reactivation',
  components: {
    ReactivationOnboardInitial,
    ReactivationWaitlistCard,
  },
  data() {
    return {
      loading: true,
      creatingCampaignBlueprint: false,
      activating: false,
    };
  },
  async created() {
    if (!this.$store.getters.reactivation.enabled) {
      this.$router.push({ name: 'reactivationpreview' });
    }

    await Promise.all([
      this.$store.dispatch(SYNC_REACTIVATION),
      this.$store.dispatch(FETCH_ORG_COUPONS),
      this.$store.dispatch(FETCH_ORG_PRICES),
      this.$store.dispatch(FETCH_ORG_PRODUCTS),
      this.$store.dispatch(FETCH_REACTIVATION_EMAIL_OPEN_COUNTS),
    ]);
    this.loading = false;
  },
  computed: {
    ...mapGetters(['primaryReactivationCampaignBlueprintId', 'senderDomainReady', 'reactivation', 'reactivationAvailable', 'isReadyToActivate']),
    hasCampaign(): boolean {
      return !!this.primaryReactivationCampaignBlueprintId;
    },
  },
  methods: {
    async createCampaignBlueprint() {
      this.loading = true;
      this.creatingCampaignBlueprint = true;

      if (!this.primaryReactivationCampaignBlueprintId) {
        // by default this will generate one if not passed as payload
        await this.$store.dispatch(CREATE_REACTIVATION_CAMPAIGN_BLUEPRINT);
        await this.$store.dispatch(SYNC_REACTIVATION);
      }
      this.$router.push({ name: 'reactivationcampaign', params: { id: this.primaryReactivationCampaignBlueprintId } });
    },
    async activateReactivation() {
      this.activating = true;
      await OrgService.updateReactivationSettings(this.$store.state.org._id, { enabled: true });
      await this.$store.dispatch('SYNC_USER_RECORD');
      this.activating = false;
      this.$router.push('/reactivation/campaigns');
    },
  },
  mounted() {
    eventBus.$on('task-completed', (taskId: string, taskType: string) => {
      if (taskType === 'BACKFILL_REACTIVATION_CAMPAIGNS') {
        this.$store.dispatch(FETCH_REACTIVATION_CAMPAIGN_COUNTS);
        this.$store.dispatch(FETCH_REACTIVATION_BLOCK_COUNTS);
      }
    });
  },
});
